import {IntegrationTypeNum} from 'enums/integrations';

export const getIsMicrosoftTeams = (type: number) => type === IntegrationTypeNum.MICROSOFT_TEAMS;
